module.exports = __webpack_public_path__ + "img/超高频RFID安全门禁.e626b5b9.jpg";